import { useTranslation } from "react-i18next";

export const useGetGreetingsOptions = (optionType: "FACE_OPTIONS" | "ACTION_OPTIONS") => {
    const { t } = useTranslation();

    const FACE_OPTIONS = [
        { label: t("APPWIDGET.GREETINGS_FACE_DEFAULT"), value: "Default" },
        { label: t("APPWIDGET.GREETINGS_FACE_ANGRY"), value: "Angry" },
        { label: t("APPWIDGET.GREETINGS_FACE_FUN"), value: "Fun" },
        { label: t("APPWIDGET.GREETINGS_FACE_JOY"), value: "Joy" },
        { label: t("APPWIDGET.GREETINGS_FACE_SORROW"), value: "Sorrow" },
        { label: t("APPWIDGET.GREETINGS_FACE_SURPRISED"), value: "Surprised" },
        { label: t("APPWIDGET.GREETINGS_FACE_FUN1"), value: "Fun1" },
        { label: t("APPWIDGET.GREETINGS_FACE_FUN2"), value: "Fun2" },
        { label: t("APPWIDGET.GREETINGS_FACE_FUN3"), value: "Fun3" },
        { label: t("APPWIDGET.GREETINGS_FACE_FUN4"), value: "Fun4" },
        { label: t("APPWIDGET.GREETINGS_FACE_NEUTRAL1"), value: "Neutral1" },
        { label: t("APPWIDGET.GREETINGS_FACE_NEUTRAL2"), value: "Neutral2" },
        { label: t("APPWIDGET.GREETINGS_FACE_NEUTRAL3"), value: "Neutral3" },
        { label: t("APPWIDGET.GREETINGS_FACE_NEUTRAL4"), value: "Neutral4" },
    ];
    const ACTION_OPTIONS = [
        { label: t("APPWIDGET.GREETINGS_ACTION_STANDBY"), value: "Standby" },
        { label: t("APPWIDGET.GREETINGS_ACTION_BODYSWAY"), value: "BodySway" },
        { label: t("APPWIDGET.GREETINGS_ACTION_COMEHERE"), value: "ComeHere" },
        { label: t("APPWIDGET.GREETINGS_ACTION_OVERLOOK"), value: "Overlook" },
        { label: t("APPWIDGET.GREETINGS_ACTION_HEARFRONT"), value: "HearFront" },
        { label: t("APPWIDGET.GREETINGS_ACTION_TURNAROUND"), value: "TurnAround" },
        { label: t("APPWIDGET.GREETINGS_ACTION_TOUCHHAIRLEFT"), value: "TouchHairLeft" },
        { label: t("APPWIDGET.GREETINGS_ACTION_LOOKAROUND"), value: "LookAround" },
        { label: t("APPWIDGET.GREETINGS_ACTION_WAVEHANDS"), value: "WaveHands" },
        { label: t("APPWIDGET.GREETINGS_ACTION_SAYHI"), value: "SayHi" },
        { label: t("APPWIDGET.GREETINGS_ACTION_TALKING"), value: "Talking" },
        { label: t("APPWIDGET.GREETINGS_ACTION_TALKCIRCLERIGHT"), value: "TalkCircleRight" },
        { label: t("APPWIDGET.GREETINGS_ACTION_TALKINTRODUCERIGHT"), value: "TalkIntroduceRight" },
        { label: t("APPWIDGET.GREETINGS_ACTION_TALKPULLHAIR"), value: "TalkPullHair" },
        { label: t("APPWIDGET.GREETINGS_ACTION_TALKSELF"), value: "TalkSelf" },
        { label: t("APPWIDGET.GREETINGS_ACTION_TALKSPREADHANDS"), value: "TalkSpreadHands" },
        { label: t("APPWIDGET.GREETINGS_ACTION_TALKTHINKING"), value: "TalkThinking" },
        { label: t("APPWIDGET.GREETINGS_ACTION_TALKHANDSSTRENGTHEN"), value: "TalkHandsStrengthen" },
        { label: t("APPWIDGET.GREETINGS_ACTION_TALKTWOHAND"), value: "TalkTwoHand" },
        { label: t("APPWIDGET.GREETINGS_ACTION_NICE"), value: "Nice" },
        { label: t("APPWIDGET.GREETINGS_ACTION_YA"), value: "Ya" },
        { label: t("APPWIDGET.GREETINGS_ACTION_CUTECAT"), value: "CuteCat" },
        { label: t("APPWIDGET.GREETINGS_ACTION_POSINGNICE"), value: "PosingNice" },
        { label: t("APPWIDGET.GREETINGS_ACTION_POSINGYA"), value: "PosingYa" },
        { label: t("APPWIDGET.GREETINGS_ACTION_RESTING"), value: "Resting" },
        { label: t("APPWIDGET.GREETINGS_ACTION_RESTING_1"), value: "Resting_1" },
        { label: t("APPWIDGET.GREETINGS_ACTION_RESTING_2"), value: "Resting_2" },
        { label: t("APPWIDGET.GREETINGS_ACTION_RESTING_3"), value: "Resting_3" },
        { label: t("APPWIDGET.GREETINGS_ACTION_THINKING"), value: "Thinking" },
        { label: t("APPWIDGET.GREETINGS_ACTION_MOVEWALK"), value: "MoveWalk" },
        { label: t("APPWIDGET.GREETINGS_ACTION_MOVEWALKLOOKAROUND"), value: "MoveWalkLookAround" },
    ];

    if (optionType === "FACE_OPTIONS") {
        return FACE_OPTIONS;
    } else if (optionType === "ACTION_OPTIONS") {
        return ACTION_OPTIONS;
    }
};
